export default {
	1: {
		name: "Basic",
		color: "white",
	},
	2: {
		name: "Uncommon",
		color: "#1eff00",
	},
	3: {
		name: "Rare",
		color: "#0070dd",
	},
	4: {
		name: "Epic",
		color: "#a335ee",
	},
	5: {
		name: "Legendary",
		color: "#ff8000",
	},
	6: {
		name: "Artifact",
		color: "#e6cc80",
	},
};